import { browserHistory } from 'react-router';
import { UCD_ROUTES_LINK, TRIDENT_CAMPAIGN_TEMPLATE, QUERY_PARAM_KEYS } from 'omega-rtc/constants/ucd';

/**
 * Handles campaign duplication by navigating to the appropriate route based on campaign type
 * @param {Object} params - The parameters for duplication
 * @param {string} params.projectId - The project ID
 * @param {string} params.campaignId - The campaign ID
 * @param {string} [params.templateType] - The template type (optional)
 * @param {Object} [params.router] - Router object for navigation (optional)
 * @param {boolean} [params.copyContent] - Whether to copy content (optional)
 * @returns {void}
 */
export const handleCampaignDuplicate = ({
  projectId,
  campaignId,
  templateType,
  router,
  copyContent,
}) => {
  const navigate = (path) => {
    if (router) {
      router.push(path);
    } else {
      browserHistory.push(path);
    }
  };

  if (templateType === TRIDENT_CAMPAIGN_TEMPLATE.smartSchedule) {
    const baseUrl = UCD_ROUTES_LINK.SMART_CAMPAIGN_DUPLICATE(projectId, campaignId);
    const url = copyContent ? `${baseUrl}&${QUERY_PARAM_KEYS.copyContent}=true` : baseUrl;
    navigate(url);
    return;
  }

  navigate(UCD_ROUTES_LINK.CAMPAIGN_DUPLICATE(projectId, campaignId));
};
